import { TimelineEventKind } from './enums/timeline-event-kind.enum';
import { TimelineEventStatus } from './enums/timeline-event-status.enum';
import { TimelineParty } from './enums/timeline-party.enum';
import { TimelineTempo } from './enums/timeline-tempo.enum';
import { TimelineAction } from './timeline-actions.model';
import { TimelineEventDependency } from './timeline-event-dependency.model';
import { DocketBuyerRow } from './docket-buyer-row.model';

export interface TimelineEvent {
    id: string;
    definitionId?: string;
    // On a Deadline Docket row: the timeline the step sits on (#1314).
    timelineId?: number;
    // Which attempt at the step this row is (#1779): 1 until the timeline resumes after a break, then 2 for
    // the new attempt beside the old one. The highest run of a definition is the live step. Undefined on a
    // row the editor has created and not yet saved.
    run?: number;
    // Set when the engagement's schedule withdrew this step after the buyer's timeline had it (#1779). Such a
    // row is history: the admin editor shows it locked, the buyer and seller views do not show it at all.
    retiredAtUtc?: string;
    masterEventId?: string;
    kind?: TimelineEventKind;
    stage: number;
    stageName?: string;
    name: string;
    party: TimelineParty;
    dependencies: TimelineEventDependency[];
    slowTempoDurationDays: number;
    mediumTempoDurationDays: number;
    fastTempoDurationDays: number;
    dayStart: number;
    dayEnd: number;
    startedAt?: string;
    completedAt?: string;
    linkedAction: TimelineAction;
    status: TimelineEventStatus;
    // On a buyer's timeline: where the engagement's main schedule stands on this step. Removing or resizing
    // is locked once it is anything but Upcoming (#1289). Undefined on the main timeline and on templates.
    masterEventStatus?: TimelineEventStatus;
    mirrorsFromMaster?: boolean;
    currentTempoDurationDays: number;
    currentTempo: TimelineTempo;
    isSuspendEvent: boolean;
    // On the seller's deadline docket only: the buyers whose own timelines hold this buyer step live.
    buyersCount?: number;
    buyerRows?: DocketBuyerRow[];
}

export const UpdateEventStatus = (
    event: TimelineEvent,
    newStatus: TimelineEventStatus
): TimelineEvent => {
    return {
        ...event,
        status: newStatus,
    };
};
